import { PackSelect } from "@components/pack-select";
import { getPackPreview } from "@features/images/use-packs";
import { Heading, Text } from "@radix-ui/themes";
import { useTranslation } from "react-i18next";
import { Link, useParams } from "react-router-dom";

interface PackModeProps {
  pack: string;
  setPack: (value: string) => void;
}

export const PackMode = ({ pack, setPack }: PackModeProps) => {
  const { t } = useTranslation();
  const { site } = useParams();

  return (
    <div className="space-y-2">
      <Heading size="2">{t("camera.form.pack")}</Heading>
      <Link to={`/${site}/templates`} className="block cursor-pointer">
        <div className="pointer-events-none">
          <PackSelect value={pack} onChange={setPack} />
        </div>
        {pack !== "none" && (
          <div className="md:block hidden">
            <div className="-mt-4 rounded-lg overflow-hidden border-2 border-slate-200 dark:border-slate-800">
              <img
                src={getPackPreview(pack)}
                alt={t(["packs." + pack + ".name", pack])}
                className="w-full h-auto object-cover"
              />
            </div>
            <Text size="1">Example image</Text>
          </div>
        )}
      </Link>
    </div>
  );
};
